
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    heading = "heading",
    quoteOwner = "quoteOwner",
    quoteDesignation = "quoteDesignation",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.heading]: string;
        [fields.quoteOwner]: string;
        [fields.quoteDesignation]: string;
    };
    extendedStyles?: CENArticlesQuoteStyles;
}

export interface CENArticlesQuoteStyles {
    quoteWrapper?: InjectableCss;
    quoteHeading?: InjectableCss;
    quoteImageWrapper?: InjectableCss;
    quoteAuthorWrapper?: InjectableCss;
    quoteDesignationWrapper?: InjectableCss;
}

export const CENarticlesQuoteStyles: CENArticlesQuoteStyles = {
    quoteWrapper: {
        css: css`
            display: flex;
            margin: 56px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                        margin: 16px;
                        `,
                        null,
                        null,
                    ],
                );
            }}
        `,
    },
    quoteHeading: {
        css: css`
            font-weight: 500 !important;
        `,
    },
    quoteImageWrapper: {
        css: css`
            margin-right: 28px;
        `,
    },
    quoteAuthorWrapper: {
        css: css`
            margin-top: 16px;

            h6 {
                margin-bottom: 4px !important;
                margin-top: 0 !important;
            }
        `,
    },
    quoteDesignationWrapper: {
        css: css`
            font-weight: 400 !important;
        `,
    },
};

const styles = CENarticlesQuoteStyles;
type Props = WidgetProps;

export const CENArticlesQuote: FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.quoteWrapper}>
            <StyledWrapper {...styles.quoteImageWrapper}>
                <Img className="CENImg" src={fields.image} altText={fields.heading} loading="lazy" />
            </StyledWrapper>
            <StyledWrapper>
                <Typography variant="h3" {...styles.quoteHeading}>
                    {translate("{0}",fields.heading)}
                </Typography>
                <StyledWrapper {...styles.quoteAuthorWrapper}>
                <Typography variant="h6">
                    {translate("{0}",fields.quoteOwner)}
                </Typography>
                <Typography variant="h6" {...styles.quoteDesignationWrapper}>
                    {translate("{0}", fields.quoteDesignation)}
                </Typography>
            </StyledWrapper>
            </StyledWrapper>
            
        </StyledWrapper>
    );
};

const ArticlesQuote: WidgetModule = {
    component: CENArticlesQuote,
    definition: {
        group: "Common",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Quote Image",
            },
            {
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.quoteOwner,
                displayName: "Quote Owner",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                fieldType: "Translatable",
                name: fields.quoteDesignation,
                editorTemplate: "TextField",
                displayName: "Quote Designation",
                defaultValue: "",
            },
        ],
    },
};

export default ArticlesQuote;
